// We dynamicaly import the svgs from the gfx folder.. and build a sprite.. and export a dictionary with references to be used.
// The sprite will be called 'sprite.svg' and placed in the /static folder during build. 


export interface IconType {
    viewBox: any;
    title: string;
  symbol: any;
}

export interface IconTypesMap {
    [k: string]: IconType;
}


let fileList = (require as any).context('../gfx/icons', true, /[\s\S]*$/);

let dictionary: IconTypesMap = {};
fileList.keys().forEach((x: string) => {
  // const match = x.match(/.*\/(.*).svg/);
    x = x.replace('./', '');
    let name = x.replace('.svg', '').toLowerCase();
    dictionary[name] = require(`../gfx/icons/${x}`);
});

export {dictionary}


export function findIcon(name: string): IconType {
  const icon: IconType = dictionary[name.toLowerCase()];
  if(icon) {
    return icon;
  }
  return undefined;
}

export function hasIcon(name: string): boolean {
  return typeof findIcon(name) !== 'undefined';
}
